module.exports = "<div class=\"row flex-items-xs-middle content-loader\">\n    <div class=\"col-xs\">\n        <div class=\"spinner spinner-lg\">\n            {{ 'common.loading' | translate }}\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/inventory-main/inventory-landing/inventory-landing.html
// module id = l4lb
// module chunks = 0